import './../../../../../core/assets/js/product';
import './../../../../../core/assets/js/product_gallery';
import './../../../../../core/assets/js/product_video';
import './shipping_location_change';

loadjs.ready(['jquery', 'core'], function() {
    var $form = $('#cart-add-form');
    var $relatedProducts = $('#related-products');
    //var $fbtProducts = $('#fbt-products');
    var $cards = $('#product-cards');
    var cardsFragmentSrc = $cards.data('src');
    var recommendationsLoaded = false;
    var $loadMoreRelatedBtn = $('#load-more-related');
    var model = 6;
    var availability = product.availability;
    var predict = function(page, notFoundCb) {
        $.post(routes.products.recommendations.replace('_hash_', product.hash), {
            uri: location.href,
            referrer: document.referrer,
            token: product.recommendationToken || '',
            page: page,
            model: model
        }, function (response) {
            if (response.length) {
                var $products = $relatedProducts.find('#products');
                if ($products.length) {
                    $products.append($(response).html())
                } else {
                    $relatedProducts.find('.related-products-container').html(response);
                }
            } else {
                notFoundCb();
            }
            preloader(false)
        })
    }
    var getRecommendations = function(useAi) {
        var getRelated = function () {
            $.get(routes.products.related.replace('_hash_', product.hash).replace('_context_', 'marketplace') + '/32', function (response) {
                $loadMoreRelatedBtn.remove();
                if (response.length) {
                    $relatedProducts.find('.related-products-container').html(response);
                } else {
                    $relatedProducts.remove();
                }
            })
        }
        recommendationsLoaded = true;
        if ($relatedProducts.length > 0) {
            if (useAi) {
                predict(1, getRelated)
            } else {
                getRelated()
            }
        }
    }
    var getEstimatedDeliveryCost = function () {
        var $estimation = $('#shipping-cost-estimation');
        $.getJSON(routes.shipping.estimation.replace('_slug_', product.shopSlug), function(response) {
            if (response.count) {
                $estimation.find('.estimation-city').html(`Livrare în <u>${response.city}</u>`);
                $estimation.find('.estimation-cost').html(response.count > 1 ? `de la ${response.cost}` : response.cost);
            } else {
                $estimation.remove();
            }
        });
    }

    $form
        .on('click', '#add-to-cart-ignore-discount', function(e) {
            e.preventDefault();
            $form.find('button[type="submit"]').trigger('click', {ignoreDiscount: 1});
        })
        .on('click', 'button[type="submit"]', function(e, payload) {
            $form.find('input[name="ignoreDiscount"]').val(payload && payload.ignoreDiscount ? '1' : '0');
        })

    $('#product-info').on('productVariantChange', function(e, variant) {
        if (variant !== null) {
            availability = variant.availability;
            $cards.data('src', cardsFragmentSrc.replace('_id_', variant.id));
            updateFragment('product-cards', getEstimatedDeliveryCost)
        }
    });
    $loadMoreRelatedBtn.click(function() {
        var page = ($loadMoreRelatedBtn.data('page') || 1) + 1;
        $loadMoreRelatedBtn.data('page', page);
        preloader(true);

        predict(page, function() {
            if ($loadMoreRelatedBtn) {
                $loadMoreRelatedBtn.remove();
            }
        })
        if (page > 2) {
            $loadMoreRelatedBtn.remove();
        }
        return false;
    })
    $('#slide-to-top').click(function() {
        $('html, body').animate({ scrollTop: 0 }, 300);
        return false;
    });

    $('#header-slider').on('slide', function() {
        gtag('event', 'product_image_slider_slide', {
            'event_label': product.id,
            'event_category': 'product_events',
            'value': this.slider.currentSlide(),
            'non_interaction': true
        });
    })

    $body
        .on('click', '[data-ga-event]', function () {
            var event = $(this).data('ga-event');
            if (event) {
                gtag('event', event, {
                    'event_label': product.id,
                    'event_category': 'product_events',
                    'value': 1,
                    'non_interaction': true
                });
            }
        })
        .on('locationChanged', function() {
            var $ratesCards = $body.find('.shop-shipping-rates-card');
            getEstimatedDeliveryCost();
            preloader(1);
            $.get(routes.shop.shippingRates.replace('_slug_', product.shopSlug) + '?rates-only=1&availability=' + availability, function(response) {
                var $r = $(response);
                $r.find('.icon').icon();
                $ratesCards.replaceWith($r);
                preloader(0);
            })
        });


    if (product.giftWrapping.length > 0) {
        var shopGiftWrappingKey = 'gwi_' + product.shopSlug;
        var disableGiftWrapping;

        try {
            disableGiftWrapping = sessionStorage.getItem(shopGiftWrappingKey) === '1';
        } catch (e) {
            disableGiftWrapping = false;
        }

        if (!disableGiftWrapping) {
            $body.on('cart:product:add', function() {
                var modalId = 'product-gift-wrapping-modal';
                preloader(1);
                $.get(product.giftWrapping, function (response) {
                    var $modal;
                    if (!response) {
                        preloader(0);
                        return;
                    }
                    $modal = $(response);
                    $modal.find('.icon').icon();
                    $modal.find('form.needs-validation').formValidate();
                    $modal.attr('id', modalId)
                    $modal.appendTo('body');
                    $modal.on('click', '.gift-wrapping-ignore', function() {
                        try {
                            sessionStorage.setItem(shopGiftWrappingKey, '1')
                        } catch (e) {}
                    })
                    $modal.find('form').on('success', function() {
                        $modal.modal('hide');
                    });

                    setTimeout(function () {
                        preloader(0);
                        $modal.one('modal:shown', function() {
                            $modal.find('.slider').slider();
                        })
                        $modal.modal('show');
                    }, 200);
                });
            });
        }
    }
    if (!product.purchasable) {
        var $restockRequestBtn = $('#restock-request');
        var $restockRequestModal = $('#restock-request-modal');
        $restockRequestBtn.click(function() {
            if (!_user) {
                var $input = $restockRequestModal.find('input');
                var $fakeInput = $input.fakeFocus();
                $restockRequestModal
                    .one('modal:shown', function() {
                        $input.focus();
                        $fakeInput.remove();
                    })
                    .modal('show')
            } else {
                $restockRequestModal.modal('show')
            }

            return false;
        })

        $restockRequestModal.on('success', function() {
            $restockRequestBtn
                .closest('.banner').hide()
                .next().removeClass('is-hidden');
            $restockRequestModal
                .find('.form').addClass('is-hidden').end()
                .find('.card-success')
                    .find('.email').html($restockRequestModal.find('input').val()).end()
                .removeClass('is-hidden')
        })
    }

    window.setLocationCookie().then(getEstimatedDeliveryCost);
    if (_isProduction) {
        getRecommendations(true);
        if (product.related) {
            gtag('event', 'related_view_item', {
                'event_label': product.id,
                'event_category': 'related_item',
                'non_interaction': true
            });
        }
    } else {
        getRecommendations(false);
    }

    // $.get(routes.products.fbt.replace('_hash_', product.hash), function (response) {
    //     if (response.length) {
    //         $fbtProducts.find('.related-products-container').html(response);
    //     } else {
    //         $fbtProducts.remove();
    //     }
    //     preloader(false)
    // })
    if (product.category) {
        gtag('event', 'product_category', {
            'event_label': product.category,
            'event_category': 'product_events',
            'non_interaction': true
        })
    }

    if (product.brand) {
        gtag('event', 'product_brand', {
            'event_label': product.brand,
            'event_category': 'product_events',
            'non_interaction': true
        })
    }

    var $anchors = $('.scroll-anchor[data-anchor]');
    if ($anchors.length) {
        $anchors.observe(function($el) {
            gtag('event', 'product_scroll', {
                'event_label': $el.data('anchor'),
                'event_category': 'product_events',
                'non_interaction': true
            })
        })
    }
});
